import React from "react";
import Header from "@/components/Header/Header";
import Footer from "@/components/Footer/Footer";
import Form from "@/components/Contact/Form";
import { useTranslation } from "@/translations/TranslationContext";
import "@/components/Contact/Contact.css";

import icon_call from "@/assets/icon_call.png";
import icon_email from "@/assets/icon_email.png";
import icon_location from "@/assets/icon_location.png";
import icon_ofctime from "@/assets/icon_ofctime.png";

const Contact = () => {
  const { t } = useTranslation();
  
  return (
    <>
      <Header />
      <div className="banner innerbanner bancontact">
        <div className="container">
          <div className="inerban">
            <span className="chips">{t.contact.banner.chips}</span>
            <h1>{t.contact.banner.title}</h1>
            <p className="text24">
              {t.contact.banner.subtitle}
            </p>
          </div>
        </div>
      </div>
      <div className="container mb150_75">
        <div className="row">
          <div className="col-lg-5">
            <div className="">
              <span className="chips">{t.contact.info.chips}</span>
              <h2>{t.contact.info.title}</h2>
              <p className="text24">
                {t.contact.info.subtitle}
              </p>
              <div className="callaction">
                <img src={icon_call} alt="icon_call" />
                <div>
                  <span>{t.contact.info.phone.label}</span>{t.contact.info.phone.value}
                </div>
              </div>
              <div className="callaction">
                <img src={icon_email} alt="icon_email" />
                <div>
                  <span>{t.contact.info.email.label}</span>{t.contact.info.email.value}
                </div>
              </div>
              <div className="callaction">
                <img src={icon_location} alt="icon_location" />
                <div>
                  <span>{t.contact.info.location.label}</span>{t.contact.info.location.value}
                </div>
              </div>
              <div className="callaction">
                <img src={icon_ofctime} alt="icon_ofctime" />
                <div>
                  <span>{t.contact.info.hours.label}</span>{t.contact.info.hours.weekdays}{" "}
                  <br />
                  {t.contact.info.hours.saturday}<br />
                  {t.contact.info.hours.sunday}
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-7">
            <Form />
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Contact;
